import Bugsnag from "@bugsnag/js";
import { IServiceStatus } from "@nju/data-access-portal-product";
import { client } from "@nju/http-client";
import { BasicError, err, isHttpError, ok } from "@nju/result";
import { IChangeSubscriptionStatusResult } from "./types";

interface IStatus {
  oldStatus:
    | IServiceStatus["ftthServiceStatus"]
    | IServiceStatus["mobileServiceStatus"];
  newStatus:
    | IServiceStatus["ftthServiceStatus"]
    | IServiceStatus["mobileServiceStatus"];
}

export async function changeSubscriptionStatus(
  productId: string,
  statuses: IStatus,
  userId?: string,
): Promise<IChangeSubscriptionStatusResult> {
  const { oldStatus, newStatus } = statuses;

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/products/${productId}
    `,
    {
      method: "patch",
      headers: {
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
      },
      searchParams: {
        ...(userId && { userId }),
      },
      json: [
        {
          op: "test", //it checks current status
          path: "/status",
          value: oldStatus,
        },
        {
          op: "replace",
          path: "/status",
          value: newStatus,
        },
      ],
    },
  );

  if (result.isError) {
    if (isHttpError(result.err) && result.err.status === 422) {
      return err(
        new BasicError({
          code: "UNSUBSCRIBE_TIME_EXPIRED",
          message:
            "Cannot unsubscribe, when anniversary date is less than 20 minutes",
        }),
      );
    }

    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
